import { render, staticRenderFns } from "./OfferteCarousel.vue?vue&type=template&id=2dd91bb6&"
import script from "./OfferteCarousel.vue?vue&type=script&lang=js&"
export * from "./OfferteCarousel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports